module.exports = __webpack_public_path__ + "static/media/Collab@2x.b873bcc3.png";